<ng-container *ngTemplateOutlet="outletTemplate" />
